<div class="animated fadeIn container-fluid" [formGroup]="form">
    <h4>Comunidad Autónoma</h4>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera"
                           [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Datos de la Comunidad Autónoma
                                <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedCabecera"
                                 [ngbCollapse]="isCollapsedCabecera">
                                <div class="row">
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="Descripcion">Descripción</label>
                                        <input formControlName="Descripcion" name="Descripcion"
                                               class="form-control"
                                               [ngClass]="displayFieldCss('Descripcion')" value="">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="Email">Email</label>
                                        <input formControlName="Email" name="Email"
                                               class="form-control"
                                               [ngClass]="displayFieldCss('Email')">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
